export const priceImportStatuses = {
  importCreated: 1,
  importValidateProcess: 2,
  importValidateDone: 3,
  tafiffUpdateProcess: 4,
  tafiffUpdateDone: 5,
  tafiffUpdateError: 6,
  importValidateError: 7,
  importDeleted: 8,
  importDeleteProcess: 9, // с бэка не приходит - для использования на фронте
} as const;
